import { environment } from '../../environments/environment';
import { socialMediaNamesArray } from 'app/shared/social-media';
import {LanguageService} from '../global-components/notification-language/language.service';
import {getInitials, getLeadFormHtml, getStickyShareContactBtn, setTypography} from './templateUtils';
import {DigitalBusinessCard} from '../digital-business-card/digital-business-card.model';
import {CONTACT_DETAIL, TYPOGRAPHY_CUSTOMIZATIONS} from '../digital-business-card/digital-business-card-utils';

function isHexColorCode(hex) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
}

function hexToRGBA(hex, opacity) {
    hex = hex.trim();
    if (!isHexColorCode(hex)) {
        return hex;
    }
    return 'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')).map(function (l) {
        return parseInt(hex.length % 2 ? l + l : l, 16)
    }).concat(isFinite(opacity) ? opacity : 1).join(',') + ')';
}

function getBoxShadowColor(card: DigitalBusinessCard , attribute: string) {

    if (card.customizations?.typography?.font_type === 'custom') {
        return hexToRGBA(card.customizations?.typography[attribute].custom_font_colour, 0.1)
    }
    if (card.customizations?.typography?.font_type === 'google') {
        return hexToRGBA(card.customizations?.typography[attribute].google_font_colour, 0.1)
    }
}

function populateDropdown(card, multiLangList, currentLanguage) {
    let dropDownHTML = `<div class="language-dropdown" style="background-color:${card.customizations.background_color}">
    <div class="beaconstac-dbc-language-dropdown-container" id="language-dropdown-container">
    <select class="beaconstac-dbc-language-dropdown"  name="language-dropdown" id="language-selector-1" autocomplete="off" disabled>`

    const languageService = new LanguageService();
    const languages = languageService.getLanguagesByCodes(multiLangList);
    const currentLanguageName = languageService.getLanguageByCode(currentLanguage);
    languages.forEach((language) => {
        const isSelected = language === currentLanguageName ? 'selected' : '';

        dropDownHTML += `<option value="${language}" ${isSelected}>${language}</option>`;
    });
    dropDownHTML += `</select>
    <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
        <path d="M6.41843 8.87328L1.92793 4.42286C1.71136 4.20822 1.71136 3.86023 1.92793 3.64562L2.45168 3.12655C2.66788 2.91228 3.01828 2.91187 3.23499 3.12563L6.81056 6.65267L10.3861 3.12563C10.6028 2.91187 10.9532 2.91228 11.1694 3.12655L11.6932 3.64562C11.9097 3.86026 11.9097 4.20824 11.6932 4.42286L7.20269 8.87328C6.98612 9.0879 6.635 9.0879 6.41843 8.87328Z" fill="white"/>
    </svg>
</div></div>`;
    return dropDownHTML;
}

export function defaultTemplateHtml(vcard_plus, isMobile, isMultiLanguageContent = false, multiLangList?, currentLanguage?) {
    let name = vcard_plus.first_name;
    if (vcard_plus.last_name) {
        name += ' '
        name += vcard_plus.last_name;
    }
    if (vcard_plus.prefix) {
        name = vcard_plus.prefix + ' ' + name
    }
    if (vcard_plus.suffix) {
        name += ', ' + vcard_plus.suffix
    }

    let multiLangDropDownHTML;
    if (isMultiLanguageContent) {
        multiLangDropDownHTML = populateDropdown(vcard_plus, multiLangList, currentLanguage);
    } else {
        multiLangDropDownHTML = '';
    }


    let htmlHeadTag =
        `<head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta http-equiv="X-UA-Compatible" content="ie=edge">
      <title>${vcard_plus.name}</title>
      <link rel="stylesheet" href="${environment.vCardPlusCssEndpoint}/vcard_plus_layout-3.css?v=6.2">
      <link rel="stylesheet" href="${environment.multiLanguageDropdownCssEndpoint}styles.css?v=3.0" />
      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Work+Sans">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" integrity="sha512-1ycn6IcaQQ40/MKBW2W4Rhis/DbILU74C1vSrLJxCq57o941Ym01SwNsOMqvEBFlcgUa6xLiPY/NS5R+E6ztJQ==" crossorigin="anonymous" referrerpolicy="no-referrer" />
      `

    if (vcard_plus.logo_url) {
        htmlHeadTag +=
            `<link rel="icon" type="image/x-icon" href="${vcard_plus.logo_url}" id = "fav_icon"/>
    <link rel="shortcut icon" type="image/x-icon" href="${vcard_plus.logo_url}" />`
    } else {
        htmlHeadTag +=
            `<link rel="icon" type="image/x-icon" href="https://d3nvy39jvu7woe.cloudfront.net/static/images/generic/favicon.ico" id = "fav_icon"/>
    <link rel="shortcut icon" type="image/x-icon" href="https://d3nvy39jvu7woe.cloudfront.net/static/images/generic/favicon.ico" />`
    }
    htmlHeadTag +=
        `<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
    <script src="https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js"></script>`

    const bioBoxShadowColor = getBoxShadowColor(vcard_plus, TYPOGRAPHY_CUSTOMIZATIONS.BIO);
    const conactDetailBoxShadowColor = getBoxShadowColor(vcard_plus, TYPOGRAPHY_CUSTOMIZATIONS.CONTACT_DETAILS)
    let styleCode = '';
    styleCode += setTypography(vcard_plus);

    htmlHeadTag += styleCode;
    htmlHeadTag += `
        <style>
          body{
            background: white;
            background-size: cover;
            background-position:center;
          }
          .content {
              word-break : break-word;
              max-width: 500px;
              margin: auto;
              min-height: calc(100vh - 42px);
              margin-bottom: ${vcard_plus.branding_footer ? '0px' : '30px'};
          }
          .secondary_data_label {
              opacity: 0.5;
          }
          html {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
              scrollbar-width: none;  /* Firefox */
          }
          html::-webkit-scrollbar {
              width: 0;
              height: 0;
          }
    #language-selector-1: disabled{
        border-radius: 4px;
        background-color: rgba(0,0,0,0.4);
        border: 0px;
        color: #FFF;
        text-align: center;
        font-family: Work Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 8px;
        padding-right: 16px;
        position: relative;
        top: 16px;
    }
    .initials_custom_styles {
        background-color: ${hexToRGBA(vcard_plus.customizations.background_color, 0.2)};
        color: ${vcard_plus.customizations.background_color};
        font-family: ${vcard_plus.customizations.font_style};
    }

    .lead-details {
        height: 23px !important;
    }

    /* Override server side added, css styles */
    .btn-container {
        cursor: unset !important;
    }

    </style>

  </head>`


    let logoImageContainer =
        `<div style="${vcard_plus.logo_url && vcard_plus.logo_size ? 'height:auto' : 'height: 40px'}; padding:24px 22px 0px 22px">`
    if (vcard_plus.logo_url) {
        logoImageContainer += `<img style="height : auto; ${vcard_plus.logo_size >= 0 ? `width: ${vcard_plus.logo_size}%` : 'max-width:150px; max-height:50px;'};" src="${vcard_plus.logo_url}">`
    }
    logoImageContainer += '</div>'



    let userInfoDiv =
        '<div class="user_info"> '
    if (vcard_plus.user_image_url) {
        userInfoDiv += `<img src="${vcard_plus.user_image_url}" class="user_image">`
    } else if (vcard_plus.first_name) {
        userInfoDiv += `<div class="user_image initials_container"><div class="user_image initials_styles initials_custom_styles">${getInitials(vcard_plus)}</div></div>`
    } else {
        userInfoDiv += `<img src="${environment.imagesEndpoint}/vcard_plus/default_vcard_image.png" class="user_image">`
    }
    userInfoDiv +=
        `<div style="display: flex; flex-direction: row;">
      <p class="user_name personal_info">${name} `

    if (vcard_plus.pronouns_v2) {
        userInfoDiv += `<span class="user_name personal_info" style="padding-left: 5px;">(${vcard_plus.pronouns_v2})</span>`
    }
    userInfoDiv += '</p></div>'

    if (vcard_plus.designation) {
        userInfoDiv += ` <p class="user_designation multi-line company_details">${vcard_plus.designation}</p>`
    }
    if (vcard_plus.company) {
        if (vcard_plus.department) {
            userInfoDiv += ` <p class="user_designation company_details" style="margin-top: 3px;">${vcard_plus.department}<span> &#x2022; </span>${vcard_plus.company}</p>`
        } else {
            userInfoDiv += ` <p class="user_designation company_details" style="margin-top: 3px;">${vcard_plus.company}</p>`
        }
    } else if (vcard_plus.department) {
        userInfoDiv += ` <p class="user_designation company_details" style="margin-top: 3px;">${vcard_plus.department}</p>`
    }
    userInfoDiv += '</div>'






    let defaultButtonHtml = '<div class="button_container ">';
    if (vcard_plus.phone_v2 && vcard_plus.phone_v2.length > 0) {
        defaultButtonHtml +=
            `<div style="margin : 0px 1rem">
           <svg width="72" height="74" viewBox="0 0 72 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_928_2440)">
                <rect x="6" y="6" width="60" height="60" rx="30" fill="white" shape-rendering="crispEdges"/>
                <path d="M32.6076 28.4123C32.7277 28.6925 32.7532 29.0043 32.6802 29.3003C32.6073 29.5964 32.4399 29.8606 32.2033 30.0529L28.6525 32.9592C30.803 37.5204 34.4737 41.1911 39.0349 43.3417L41.9412 39.7908C42.1339 39.5547 42.3981 39.3877 42.694 39.3148C42.9899 39.2418 43.3015 39.267 43.5818 39.3865M32.6076 28.4123L29.7951 21.8497M32.6076 28.4123L32.1481 28.6093L32.148 28.6092M32.6076 28.4123L32.148 28.6092M29.7951 21.8497C29.6633 21.5476 29.4302 21.3009 29.1361 21.1522C28.8419 21.0035 28.5051 20.9622 28.1837 21.0352M29.7951 21.8497L29.3368 22.0496L32.148 28.6092M29.7951 21.8497L29.3355 22.0466L29.3362 22.0482C29.2508 21.8534 29.1004 21.6944 28.9105 21.5985C28.7205 21.5024 28.5029 21.4756 28.2952 21.5226L28.2961 21.5224L28.1837 21.0352M28.1837 21.0352L22.0899 22.4415M28.1837 21.0352L28.2945 21.5228L22.2024 22.9287L22.0899 22.4415M22.0899 22.4415C21.78 22.513 21.5035 22.6875 21.3056 22.9364C21.1077 23.1853 20.9999 23.494 21 23.812C21 38.8416 33.1819 51 48.188 51C48.5061 51.0002 48.8149 50.8925 49.0639 50.6946C49.313 50.4966 49.4875 50.2201 49.5591 49.9101M22.0899 22.4415L22.2023 22.9287C22.0026 22.9748 21.8245 23.0872 21.6969 23.2476C21.5694 23.408 21.5 23.607 21.5 23.8119L21.5 23.812C21.5 38.5652 33.4577 50.5 48.188 50.5H48.1883C48.3933 50.5001 48.5923 50.4307 48.7528 50.3032C48.9133 50.1756 49.0258 49.9974 49.0719 49.7977L49.5591 49.9101M49.5591 49.9101L50.9654 43.8163M49.5591 49.9101L49.0719 49.7976L50.4775 43.7066L50.9654 43.8163M50.9654 43.8163C51.0379 43.4933 50.9957 43.1551 50.8459 42.86C50.696 42.5648 50.448 42.3311 50.1445 42.1991M50.9654 43.8163L50.4782 43.7038L50.4778 43.7054C50.5245 43.4963 50.497 43.2774 50.4 43.0863C50.303 42.8952 50.1426 42.7438 49.9462 42.6581L49.9475 42.6586L50.1445 42.1991M50.1445 42.1991L43.5818 39.3865M50.1445 42.1991L49.945 42.6576L43.3858 39.8465L43.5818 39.3865M43.5818 39.3865L43.3849 39.8461L43.3857 39.8464C43.2051 39.7695 43.0043 39.7533 42.8137 39.8002C42.623 39.8472 42.4527 39.9549 42.3285 40.107L42.3281 40.1075L39.4218 43.6583L39.1746 43.9603L38.8217 43.7939C34.1555 41.5938 30.4003 37.8387 28.2002 33.1725L28.0338 32.8195L28.3358 32.5723L31.8866 29.666L31.8878 29.665C32.0401 29.5412 32.1478 29.3712 32.1947 29.1807C32.2417 28.9902 32.2253 28.7895 32.148 28.6092" stroke="${vcard_plus.customizations.icon_color}"/>
                </g>
                <defs>
                <filter id="filter0_d_928_2440" x="2" y="6" width="68" height="68" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="4"/>
                <feGaussianBlur stdDeviation="2"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_928_2440"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_928_2440" result="shape"/>
                </filter>
                </defs>
              </svg>
        </div>`
    }

    if (vcard_plus.email_v2) {
        defaultButtonHtml +=
            `<div style="margin : 0px 1rem">
           <svg width="72" height="74" viewBox="0 0 72 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_937_4811)">
                <rect x="6" y="6" width="60" height="60" rx="30" fill="white" shape-rendering="crispEdges"/>
                <path d="M51.5 31.5V30.7433V30.5V30.4999V30.4999V30.4997V30.4996V30.4994V30.4992V30.499V30.4987V30.4984V30.4981V30.4977V30.4973V30.4969V30.4965V30.496V30.4955V30.4949V30.4944V30.4938V30.4931V30.4925V30.4918V30.4911V30.4903V30.4895V30.4887V30.4879V30.487V30.4861V30.4852V30.4843V30.4833V30.4823V30.4813V30.4802V30.4791V30.4785V30.478V30.4768V30.4757V30.4745V30.4732V30.472V30.4707V30.4694V30.468V30.4667V30.4653V30.4638V30.4624V30.4609V30.4594V30.4579V30.4563V30.4548V30.4532V30.4515V30.4499V30.4482V30.4465V30.4448V30.443V30.4412V30.4394V30.4376V30.4357V30.4338V30.4319V30.43V30.428V30.426V30.424V30.422V30.4199V30.4179V30.4158V30.4136V30.4115V30.4093V30.4071V30.4049V30.4026V30.4004V30.3981V30.3958V30.3934V30.3911V30.3887V30.3863V30.3838V30.3814V30.3789V30.3764V30.3739V30.3714V30.3688V30.3662V30.3636V30.361V30.3583V30.3557V30.353V30.3503V30.3475V30.3448V30.342V30.3392V30.3364V30.3336V30.3307V30.3278V30.3249V30.322V30.3191V30.3161V30.3132V30.3102V30.3071V30.3041V30.3011V30.298V30.2949V30.2918V30.2886V30.2855V30.2823V30.2791V30.2759V30.2727V30.2695V30.2662V30.2629V30.2596V30.2563V30.253V30.2496V30.2463V30.2429V30.2395V30.2361V30.2326V30.2292V30.2257V30.2222V30.2187V30.2152V30.2117V30.2081V30.2045V30.201V30.1974V30.1937V30.1901V30.1865V30.1828V30.1791V30.1754V30.1717V30.168V30.1642V30.1605V30.1567V30.1529V30.1491V30.1453V30.1415V30.1376V30.1338V30.1299V30.126V30.1221V30.1182V30.1143V30.1103V30.1064V30.1024V30.0984V30.0944V30.0904V30.0864V30.0823V30.0783V30.0742V30.0702V30.0661V30.062V30.0579V30.0537V30.0496V30.0455V30.0413V30.0371V30.0329V30.0288V30.0245V30.0203V30.0161V30.0119V30.0076V30.0034V29.9991V29.9948V29.9905V29.9862V29.9819V29.9776V29.9732V29.9689V29.9645V29.9602V29.9558V29.9514V29.947V29.9426V29.9382V29.9338V29.9293V29.9249V29.9204V29.916V29.9115V29.907V29.9026V29.8981V29.8936V29.8891V29.8845V29.88V29.8755V29.8709V29.8664V29.8618V29.8573V29.8527V29.8481V29.8435V29.8389V29.8343V29.8297V29.8251V29.8205V29.8159V29.8113V29.8066V29.802V29.7973V29.7927V29.788V29.7833V29.7787V29.774V29.7693V29.7646V29.7599V29.7552V29.7505V29.7458V29.7411V29.7363V29.7316V29.7269V29.7221V29.7174V29.7127V29.7079V29.7032V29.6984V29.6937V29.6889V29.6841V29.6794V29.6746V29.6698V29.665V29.6602V29.6555V29.6507V29.6459V29.6411V29.6363V29.6315V29.6267V29.6219V29.6171V29.6123V29.6075V29.6026V29.5978V29.593V29.5882V29.5834V29.5786V29.5737V29.5689V29.5641V29.5593V29.5544V29.5496V29.5448V29.54V29.5351V29.5303V29.5255V29.5207V29.5158V29.511V29.5062V29.5014V29.4965V29.4917V29.4869V29.4821V29.4772V29.4724V29.4676V29.4628V29.458V29.4531V29.4483V29.4435V29.4387V29.4339V29.4291V29.4243V29.4195V29.4147V29.4099V29.4051V29.4003V29.3955V29.3907V29.3859V29.3812V29.3764V29.3716V29.3668V29.3621V29.3573V29.3525V29.3478V29.343V29.3383V29.3335V29.3288V29.324V29.3193V29.3146V29.3099V29.3051V29.3004V29.2957V29.291V29.2863V29.2816V29.2769V29.2722V29.2676V29.2629V29.2582V29.2536V29.2489V29.2443V29.2396V29.235V29.2304V29.2257V29.2211V29.2165V29.2119V29.2073V29.2027V29.1981V29.1936V29.189V29.1844V29.1799V29.1753V29.1708V29.1663V29.1617V29.1572V29.1527V29.1482V29.1437V29.1393V29.1348V29.1303V29.1259V29.1214V29.117V29.1126V29.1081V29.1037V29.0993V29.0949V29.0906V29.0862V29.0818V29.0775V29.0731V29.0688V29.0645V29.0602V29.0559V29.0516V29.0473V29.043V29.0388V29.0345V29.0303V29.0261V29.0219V29.0177V29.0135V29.0093V29.0051V29.001V28.9968V28.9927V28.9886V28.9845V28.9804V28.9763V28.9722V28.9682V28.9641V28.9601V28.9561V28.9521V28.9481V28.9441V28.9402V28.9362V28.9323V28.9284V28.9244V28.9206V28.9167V28.9128V28.909V28.9051V28.9013V28.8975V28.8937V28.8899V28.8861V28.8824V28.8787V28.8749V28.8712V28.8675V28.8639V28.8602V28.8566V28.8529V28.8493V28.8457V28.8422V28.8386V28.835V28.8315V28.828V28.8245V28.821V28.8176V28.8141V28.8107V28.8073V28.8039V28.8005V28.7972V28.7938V28.7905V28.7872V28.7839V28.7806V28.7774V28.7741V28.7709V28.7677V28.7645V28.7614V28.7582V28.7551V28.752V28.7489V28.7459V28.7428V28.7398V28.7368V28.7338V28.7308V28.7279V28.725V28.7221V28.7192V28.7163V28.7134V28.7106V28.7078V28.705V28.7023V28.6995V28.6968V28.6941V28.6914V28.6888V28.6861V28.6835V28.6809V28.6783V28.6758V27.5625C51.5 25.7336 50.0164 24.25 48.1875 24.25H23.8125C21.9836 24.25 20.5 25.7336 20.5 27.5625V28.6758L20.5 29.7505L20.5 30.2759L20.5 30.4394L20.5 30.4843L20.5 30.496L20.5 30.499V30.4997V30.4999V30.5H20.5001V30.5H20.5L20.5 30.7439L20.5001 30.744L20.5 31.5L21 31.5L20.5 31.5V31.5V31.5001V31.5005L20.5 31.5019L20.5 31.5076L20.5 31.5293L20.5 31.6089L20.5 31.8706L20.5 32.4609V44.4375C20.5 46.2664 21.9836 47.75 23.8125 47.75H48.1875C50.0164 47.75 51.5 46.2664 51.5 44.4375V31.5ZM20.5277 30.5L20.5277 30.5L21 30.5L20.5277 30.5ZM45.7415 35.0001C45.7548 34.9905 45.768 34.9809 45.7812 34.9714C44.5401 35.9175 43.0138 37.0574 41.1143 38.4373L41.1137 38.4378C40.9128 38.5842 40.6984 38.7502 40.4701 38.9269C39.9734 39.3112 39.4107 39.7467 38.7767 40.1446C38.5193 40.3062 38.2589 40.4553 37.9977 40.5861C38.1913 40.474 38.3823 40.3537 38.5678 40.2303C39.0939 39.8806 39.6251 39.4705 40.0523 39.1407C40.2626 38.9784 40.4476 38.8355 40.5945 38.7289C42.7807 37.1423 44.4423 35.9401 45.7415 35.0001ZM33.4322 40.2303C33.6045 40.3449 33.7815 40.4568 33.961 40.562C33.7221 40.4401 33.4838 40.3031 33.2477 40.1553C32.6165 39.7601 32.0519 39.3243 31.5464 38.9341C31.3164 38.7565 31.0987 38.5884 30.8924 38.4379L30.8916 38.4373C29.0221 37.0792 27.5135 35.9535 26.2822 35.0163C26.3403 35.0583 26.3991 35.1009 26.4587 35.144C27.7273 36.0624 29.3299 37.2226 31.4054 38.7288C31.5523 38.8355 31.7374 38.9784 31.9477 39.1407C32.3749 39.4705 32.9061 39.8806 33.4322 40.2303Z" stroke="${vcard_plus.customizations.icon_color}"/>
                </g>
                <defs>
                <filter id="filter0_d_937_4811" x="2" y="6" width="68" height="68" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="4"/>
                <feGaussianBlur stdDeviation="2"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_937_4811"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_937_4811" result="shape"/>
                </filter>
                </defs>
           </svg>

        </div>`
    }

    if (vcard_plus.address_url) {
        defaultButtonHtml +=
            ` <div style="margin : 0px 1rem">
                <svg width="72" height="74" viewBox="0 0 72 74" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_937_4806)">
                    <rect x="6" y="6" width="60" height="60" rx="30" fill="white" shape-rendering="crispEdges"/>
                    <path d="M35.255 50.1102C33.7244 47.8914 32.4213 46.035 31.3125 44.4554C29.3256 41.625 27.9626 39.6834 27.0328 38.1373C26.3147 36.9434 25.874 36.0146 25.6094 35.1211C25.3459 34.2315 25.25 33.3527 25.25 32.25C25.25 26.3129 30.0629 21.5 36 21.5C41.9371 21.5 46.75 26.3129 46.75 32.25C46.75 33.3527 46.6541 34.2315 46.3906 35.1211C46.126 36.0146 45.6852 36.9434 44.9672 38.1373C44.0374 39.6834 42.6744 41.625 40.6875 44.4554C39.5787 46.035 38.2756 47.8913 36.7451 50.1101C36.3852 50.6299 35.6148 50.6299 35.255 50.1102ZM36 37.4375C38.865 37.4375 41.1875 35.115 41.1875 32.25C41.1875 29.385 38.865 27.0625 36 27.0625C33.135 27.0625 30.8125 29.385 30.8125 32.25C30.8125 35.115 33.135 37.4375 36 37.4375Z" stroke="${vcard_plus.customizations.icon_color}"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_937_4806" x="2" y="6" width="68" height="68" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_937_4806"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_937_4806" result="shape"/>
                    </filter>
                    </defs>
                </svg>


            </div>`
    }

    defaultButtonHtml += '</div>'


    let htmlBodyCode = `<body style="margin: 0; ${isMobile ? '' : `zoom: ${vcard_plus.__zoom__}`};" id="body">

  <div class="content">
  ${multiLangDropDownHTML}
      <div style="background-color: ${vcard_plus.customizations.background_color}; padding-bottom: 70px; padding-left: 2px; padding-right: 2px;">
        ${logoImageContainer}
        ${userInfoDiv}
      </div>

      ${defaultButtonHtml}


      <div style="padding-bottom: 80px; padding-left: 15px; padding-right: 15px ;">`
    if (vcard_plus.phone_v2 && vcard_plus.phone_v2.length > 0 || vcard_plus.email_v2 && vcard_plus.email_v2.length > 0 || vcard_plus.address_url) {
        if (vcard_plus.summary) {
            htmlBodyCode +=
                `<div class="summary_container" style="box-shadow: 0 2px 0 ${bioBoxShadowColor}">
          <p style="white-space: pre-line ;" class="summary bio secondary_data">${vcard_plus.summary}</p>
      </div>
      <div style="margin: -50px"></div>`
        } else {
            htmlBodyCode += '<div style="margin: -30px"></div>'
        }
    } else {
        htmlBodyCode +=
            `<div class="section_container">
        <p class="summary bio secondary_data">${vcard_plus.summary}</p>
    </div>`
    }

    vcard_plus.__contact_info_list__.forEach((contact) => {
        let tempCode = ''
        if (contact.value.length > 0) {
            switch (contact.key) {
                case CONTACT_DETAIL.PHONE_V2:
                    contact.value.forEach(item => {
                        if (item.value && item.value.trim() !== '') {
                            if (item.label) {
                                tempCode += `<p style="padding-bottom: 0;" class="title titleColor secondary_data_label contact_details">${item.label.charAt(0).toUpperCase() + item.label.slice(1)}</p>`
                            }
                            tempCode +=
                            `<a style="text-decoration: none;">
                                <p style="padding-top : 15px;" class="contact_paragraph secondary_data contact_details">${item.value}</p>
                            </a>
                            <div style="margin: -20px"></div>`
                        }
                    });
                    if (tempCode.length) {
                        htmlBodyCode += `<div style="line-height: 1.5; box-shadow: 0 2px 0 ${conactDetailBoxShadowColor}" class="section_container contact_details"> ${tempCode} </div>`
                    }
                    break;
                case CONTACT_DETAIL.EMAIL_V2:
                    contact.value.forEach(item => {
                        if (item.value && item.value.trim() !== '') {
                            if (item.label) {
                                tempCode += `<p style="padding-bottom: 0;" class="title titleColor secondary_data_label contact_details">${item.label.charAt(0).toUpperCase() + item.label.slice(1)}</p>`
                            }

                            tempCode +=
                            `<a style="text-decoration: none;">
                                <p style="padding-top : 15px;"  class="contact_paragraph secondary_data contact_details">${item.value}</p>
                            </a>
                            <div style="margin: -20px"></div>`
                        }
                    });
                    if (tempCode.length) {
                        htmlBodyCode += `<div style="line-height: 1.5;  box-shadow: 0 2px 0 ${conactDetailBoxShadowColor}" class="section_container contact_details"> ${tempCode} </div>`
                    }
                    break;
                case CONTACT_DETAIL.WEBSITE_V2:
                    contact.value.forEach(item => {
                        if (item.value && item.value.trim() !== '') {
                            if (item.label) {
                                tempCode += `<p style="padding-bottom: 0;" class="title titleColor secondary_data_label contact_details">${item.label.charAt(0).toUpperCase() + item.label.slice(1)}</p>`
                            }
                            tempCode +=
                            `<a style="text-decoration: none;">
                                <p style="padding-top : 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"  class="contact_paragraph secondary_data contact_details">${item.value}</p>
                            </a>
                            <div style="margin: -20px"></div>`
                        }
                    });
                    if (tempCode.length) {
                        htmlBodyCode += `<div style="line-height: 1.5;  box-shadow: 0 2px 0 ${conactDetailBoxShadowColor}" class="section_container contact_details"> ${tempCode} </div>`
                    }
                    break;
                case CONTACT_DETAIL.CUSTOM_FIELDS:
                    contact.value.forEach(item => {
                        if (item.value && item.value.trim() !== '') {
                            if (item.label) {
                                tempCode += `<p style="padding-bottom: 0; line-height: 1; margin-top: -7px; margin-bottom: -7px;" class="title titleColor secondary_data_label">${item.label}</p>`
                            }
                            tempCode +=
                            `<a style="text-decoration: none;">
                                <p style="padding-top : 15px;"  class="contact_paragraph secondary_data contact_details">${item.value}</p>
                            </a>
                            <div style="margin: -30px"></div>`
                        }
                    });
                    if (tempCode.length) {
                        htmlBodyCode += `<div style="line-height: 1.5; padding-bottom: 25px; box-shadow: 0 2px 0 ${conactDetailBoxShadowColor}" class="section_container contact_details"> ${tempCode} </div>`
                    }
                    break;
            }
        }
    })


    if (vcard_plus.address_v2) {
        const tempAddress = vcard_plus.address_v2.replace(/ +\n/g, '\n').replace(/\n +/g, '\n').trim();
        htmlBodyCode +=
            `<div class="section_container" style="box-shadow: 0 2px 0 ${conactDetailBoxShadowColor}">
          <p class="title titleColor secondary_data_label contact_details">Address</p>
          <div style="line-height: 1.5">
              <pre style="line-height: 21px; word-break: break-word; text-wrap:auto;" class="paragraph secondary_data contact_details">${tempAddress}</pre>
          </div>
      </div>`
    }

    /* Commenting as the font-awesome icon is not working on production */
    // htmlBodyCode += `<a data-open="modal" id="vcard-download">
    //                    <div class="button" ><i class="fa fa-user-plus" id="floatingButton" style="background-color: ${vcard_plus.customizations.button_color}"></i></div>
    //                 </a>`


    let socialMediaIcons = ''
    socialMediaNamesArray.forEach(item => {
        const imgLink = item;
        if (vcard_plus.social_links[item]) {
            socialMediaIcons +=
                `<a class="grid-item" style="background-color: transparent">
          <img src="${environment.imagesEndpoint}/vcard_plus/social_link_icons/${imgLink}_icon.png" class="social_logo">
      </a>`
        }
    })




    const socialMediaContainer =
        `<div class="button_icon_container" style="background-color: transparent">
    ${socialMediaIcons}
  </div>`



    htmlBodyCode += socialMediaContainer;
    if (!vcard_plus.__show_new_sticky_btn__) {
        if (vcard_plus.lead_collection) {
            htmlBodyCode += `<div id="leadModalBtn" class="flex-center" style=" border: 2px solid ${vcard_plus.customizations.button_color}">
                    <div class="flex-center button" style="cursor: pointer; color: ${vcard_plus.customizations.button_color};">
                        Share your contact
                    </div>
                </div>
        `
        }
    }
    htmlBodyCode += '</div>';
    if (vcard_plus.__show_new_sticky_btn__) {
        htmlBodyCode += getStickyShareContactBtn(vcard_plus);
    }
    htmlBodyCode += '</div>';
    htmlBodyCode += getLeadFormHtml(vcard_plus);
    htmlBodyCode += `<script>
        WebFont.load({
                    google: {
                           families: ['${vcard_plus.customizations.font_style}']
                     }
         });
        (function () {
            const container = document.getElementById('body');
            const backgroundType = '${vcard_plus.customizations.background.type}';
            const backgroundValue = '${vcard_plus.customizations.background.value}';

            if (backgroundType === 'color') {
              container.style.backgroundColor = backgroundValue;
            } else {
              container.style.backgroundImage = "url('" + backgroundValue + "')";
            }
        })();
   </script>
</body>`






    const pageHtmlCode =
        `<!DOCTYPE html>
  <html lang="en">
  ${htmlHeadTag}
  ${htmlBodyCode}
  </html>`;


    return pageHtmlCode;
}
